import { useState, useEffect } from 'react';

export default function PDFViewer({ content, blockWidth }) {
    const [zoomLevel, setZoomLevel] = useState(100);

    // Effect to recalculate zoom when blockWidth changes
    useEffect(() => {
        const calculateZoom = () => {
            const baseWidth = 1200;  // Assume 800px as a typical base width for a PDF page
            const zoomPercentage = (blockWidth - 40) / baseWidth * 100;
            setZoomLevel(zoomPercentage);
        };

        calculateZoom();
    }, [blockWidth]);

    return (
        <iframe 
            src={`${content}#zoom=${zoomLevel}`}  // Dynamic zoom based on block width
            width={blockWidth - 40}  // Custom width
            height={Math.min((blockWidth - 40) * 1.3, window.innerHeight * 0.8)}  // Proportional height with a cap at 80% screen height
            style={{
                position: 'relative',
                left: '20px',
                border: 'none',  // Removes the iframe border for a cleaner look
            }} 
            title="PDF Document" 
        />
    );
}